import { isEqual } from 'lodash';
import { useDispatch } from 'react-redux';
import {
  createCustodian,
  updateCustodian,
} from '../store/actions/custodians/custodiansActions';
import useApplicationUid from './useApplicationUid';

const useCustodianInformationDispatch = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();

  const custodianInformationDispatch = ({ data, defaultValues, onSuccess }) => {
    const shouldSkip = isEqual(data, defaultValues);

    if (shouldSkip) {
      onSuccess();
      return;
    }

    const requestData = {
      ApplicationUid,
      data,
      onSuccess,
    };

    if (defaultValues?.Name) {
      dispatch(
        updateCustodian({
          ...requestData,
        }),
      );
      return;
    }

    dispatch(
      createCustodian({
        ...requestData,
      }),
    );
  };

  return { custodianInformationDispatch };
};

export default useCustodianInformationDispatch;
